import React, { Component } from 'react';
import _, { startCase , sortBy } from 'lodash';
import { DateTime } from 'luxon';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import FormFlowWrapper from '../../theme/wrappers/FormFlowWrapper';
import { getJsonFromUrl } from '../../../utils/parseUrl';
import api from '../../../store/api';
import {
	toggleGlobalLoader,
	addErrorAlert,
} from '../../../store/calls/alertLoadingDispatch';
import * as actions from '../../../store/actions';
import { mountApplication } from '../../../store/calls/applicationData';
import formatters from '../../../utils/forms/formatters';
import Input from '../../theme/forms/Input';

// imported child components
import ProjectCard from '../../subcomponents/loanEstimates/ProjectCard';
import LoanEstimateCard from '../../subcomponents/loanEstimates/loanEstimateCard';
import NotesCard from '../../subcomponents/loanEstimates/NotesCard';
import explanations from '../../../utils/explanations';
import LoanEstimateShareModal from '../../subcomponents/loanEstimates/LoanEstimateShareModal';
import AlertCard from '../../theme/cards/AlertCard';
import TelephoneNumber from '../../subcomponents/TelephoneNumber';
import AmortizationModal from '../../theme/modals/AmortizationModal';
import FormModal from '../../theme/modals/FormModal';
import validators from '../../../utils/forms/validators';
import LoginModal from '../../subcomponents/auth/LoginModal';
import { updateOrCreateProjectLead } from '../../../store/calls/indicativeOptionData';
import PPADisplay from '../../subcomponents/loanEstimates/PPADisplay';
import HowThisWorksCard from '../../subcomponents/loanEstimates/HowThisWorksCard';
import ToggleCard from '../../theme/cards/ToggleCard';
import ContactEmail from '../../subcomponents/ContactEmail';
import MultiSelectBox from '../../theme/buttons/MultiSelectBox';

export class AdminInfoLoanEstimate extends React.Component {
	static defaultProps = {
		notes: [],
	};

	constructor(props) {
		super(props);
		let { startOpen } = this.props;
		this.state = {
			open: startOpen,
			isHovered: false,
			chartModalData: null,
		};
	}

	render() {
		let notes = this.props.notes || [];
		notes = sortBy(notes, ['order', 'title']);

		let rows = notes.map((note) => {
			return (
				<tr key={note.title}>
					<td
						className="is-size-7 has-text-weight-semibold"
						dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note.title) }}
					/>
					<td
						className="has-text-grey is-size-7"
						dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note.note) }}
					/>
				</tr>
			);
		});

		return (
			<div className={`${this.state.open ? 'mt-3 mb-5' : 'my-3'}`}>
				{this.props.title && (
					<div
						className={`is-flex justify-space-between is-align-items-center has-icons-and-text-aligned is-clickable ${
							this.state.open || this.state.isHovered
								? 'has-text-black-bis'
								: 'has-text-grey'
						}`}
						onClick={() => {
							this.setState({ open: !this.state.open });
						}}
						onMouseEnter={() => this.setState({ isHovered: true })}
						onMouseLeave={() => this.setState({ isHovered: false })}
					>
						<p className={`is-size-5 `}>{this.props.title}</p>
						<i
							className={`fa ${
								this.state.open ? 'fa-chevron-down' : 'fa-chevron-left'
							} mt-2 is-size-5`}
						/>
					</div>
				)}

				<div
					className="table-container"
					style={this.state.open ? { height: 'unset' } : { height: 0 }}
				>
					{this.props.children}
					<table className="table is-fullwidth">
						<tbody>{rows}</tbody>
					</table>
				</div>
			</div>
		);
	}
}

class LoanEstimateScreen extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: {
				project: {},
				estimates: [],
			},
			bidDeskView: false,
			loading: true,
			shared_version: false,
			shareModalOpen: false,
			shareModalSpecOptionIds: [],
			showNoPaceFunderFlag: false,
			amortizationModalOpen: false,
			amortizationOptionId: [],
			amortizationLineId: null,
			showDuplicationModal: false,
			availableTypes: [],
			displayedTypes: [],
		};
	}

	componentDidMount() {
		let query_params = getJsonFromUrl(window.location.href);
		this.pullData(query_params).then(() => {
			if (query_params.a) {
				const application_estimate = this.state.data.estimates.find(
					(d) => d.id === query_params.a
				);
				if (application_estimate) this.handleApplyRequest(application_estimate);
			}
		});
	}

	handleEditProjectRequest = () => {
		let projectLead = this.state?.data?.project_lead || {};
		this.props.setFocusedProject(projectLead.id);

		const formFlowComputed = {
			address: projectLead.address,
			programs: projectLead.programs,
		};

		this.props.clearFormFlow();
		this.props.updateInputs({
			...projectLead,
			business_type: projectLead.business_type?.id,
			asset_type: projectLead.asset_type?.id,
			id: projectLead.id,
		});
		this.props.updateComputed(formFlowComputed);
		this.props.updateCurrentStep(2);

		this.props.history.push({
			pathname: '/project',
		});
	};

	handleDuplicateProjectRequest = ({ name }) => {
		let projectLead = this.state?.data?.project_lead || {};
		this.props.setFocusedProject(null);

		const formFlowComputed = {
			address: projectLead.address,
			programs: projectLead.programs,
		};

		this.props.clearFormFlow();
		this.props.updateInputs({
			...projectLead,
			business_type: projectLead.business_type?.id,
			asset_type: projectLead.asset_type?.id,
			id: 'X',
			project_name: name,
		});
		this.props.updateComputed(formFlowComputed);
		this.props.updateCurrentStep(1);

		this.props.history.push({
			pathname: '/project',
		});
	};

	pullData = (query_params) => {
		const lead_id = this.props.match.params.projectLeadId;
		toggleGlobalLoader(true);
		let get_promise;
		if (query_params.g || query_params.o) {
			this.setState({ shared_version: true });
			get_promise = api.get(`/estimate-group/`, query_params);
		} else {
			get_promise = api.get(`/project-estimate/${lead_id}`);
		}

		return get_promise
			.then((res) => {
				// handle case that project is in pace district but we don't have funders
				const data = _.cloneDeep(res.data);
				this.props.setFocusedLoanEstimate(data);
				let availableTypes = [
					...new Set(
						(data.estimates || [])
							.map((d) => d?.product?.type)
							.filter((d) => ![null, undefined, 'PACE PPA'].includes(d))
					),
				];

				let displayedTypes = [...availableTypes].filter((d) => d !== 'PPA');

				this.setState({ availableTypes, displayedTypes, data });
			})
			.catch((err) => {
				if (!err.response) {
					this.setState({
						error:
							"There seems to have been a connectivity issue, we couldn't complete the build process with our server.",
					});
				}

				if (_.get(err, 'response.data.error')) {
					this.setState({ error: _.get(err, 'response.data.error') });
				} else {
					console.error(err);
					this.setState({
						error:
							"Something went wrong, and we weren't able to build the indicative.",
					});
				}
			})
			.then(() => {
				toggleGlobalLoader(false);
				this.setState({ loading: false });
			});
	};

	renderTabs = () => {
		return (
			<div className="tabs is-centered is-boxed mt-5 no-print">
				<ul>
					{this.state.data.map((d, i) => {
						if (i < 3)
							return (
								<li
									className={i === this.state.selected_index ? 'is-active' : ''}
								>
									<a
										onClick={() => this.setState({ selected_index: i })}
										className="has-text-semibold is-size-4"
									>
										Option {i + 1}
									</a>
								</li>
							);
					})}
				</ul>
			</div>
		);
	};

	duplicateProject = () => {
		return updateOrCreateProjectLead({
			user: this.props.userData.user_id,
			data: {
				...this.props.focusedLoanEstimate.project_lead,
				id: null,
				user: null,
			},
		});
	};

	handleApplyRequest = async (loanEstimate) => {
		this.props.clearFormFlow();
		this.props.resetApplicationData();

		let projectData = this.props.focusedLoanEstimate?.project_lead;

		// short circuit this function if the user is not logged in.
		if (!this.props.userData?.user_id) {
			// set on login path back to this url with the id in the 'a' query search param, so we can fire this function if we leave the page in the login process
			this.setState(
				{ showLoginModal: true, applicationLoanEstimate: loanEstimate },
				() => {
					const {
						location: { search, origin, pathname },
					} = window;
					const queryParams = new URLSearchParams(search);
					queryParams.set('a', loanEstimate.id);
					this.props.setSessionVar({
						onLoginPath: `${pathname}?${queryParams.toString()}`,
					});
				}
			);

			return;
		}
		if (
			this.props.focusedLoanEstimate?.project_lead?.user !==
			this.props.userData.user_id
		) {
			try {
				let projectData_resp = await api.post('/duplicate-project', {
					project: projectData.id,
				});
				projectData = {
					...projectData_resp.data.data,
					id: projectData_resp.data.id,
				};
			} catch (e) {
				console.error(e);
				addErrorAlert(
					'There was an unexpected problem building that application'
				);
				return;
			}
		}

		return mountApplication({
			projectData,
			loanEstimateData: loanEstimate,
		})
			.then((applicationData) => {
				console.log(applicationData.id, "Application Data")
				this.props.history.push(
					`/apply${applicationData.id ? '/' + applicationData.id : ''}`
				);
			})
			.catch(() => {
				addErrorAlert('We had a problem building that application');
			});
	};

	generateNoFunderCase = () => {
		const { data } = this.state;
		return (
			<FormFlowWrapper controlWidth>
				{this.state.error && (
					<AlertCard type="danger" msg={this.state.error} bold />
				)}

				{/* HANDLE CASE OF NO FUNDERS */}
				{!data.length && !this.props.loaderOn && !this.state.error && (
					<div className="card m-4 mt-6">
						<div className="card-content">
							<div className="is-flex m-4 is-justify-content-center is-align-items-center is-flex-direction-column">
								<h4 className="is-size-4 has-text-primary mx-6 mb-5">
									Unfortunately, there were no matching Financing Products.
								</h4>
								<h4 className="is-size-6 has-text-secondary mx-6">
									We regret that no funder on our platform currently finances
									projects such as the one you have described. While this could
									change soon, our loan specialists will be able to find a
									solution for your needs. write us at{' '}
									<a href="mailto:admin@pacefi.com ">admin@pacefi.com</a> or
									call us directly, at <TelephoneNumber />
								</h4>
								<div className="buttons mt-5">
									<div
										className="button is-link is-outlined"
										onClick={() => (window.location = '/my-projects')}
									>
										Edit Project
									</div>
									<div
										className="button is-link is-outlined"
										onClick={() => (window.location = '/')}
									>
										Look up another address
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
			</FormFlowWrapper>
		);
	};

	generateTitle = () => {
		return (
			<div className="columns mb-6 no-print">
				<div className="column is-flex-direction-column is-align-items-flex-start">
					<p className="is-size-3 has-text-primary">Your Funding Options</p>
				</div>
				<div className="column">
					<div className="buttons">
						{!this.state.shared_version && (
							<button
								className="button is-link"
								onClick={() =>
									this.setState({
										shareModalOpen: true,
										shareModalSpecOptionIds: [],
									})
								}
							>
								Share All Options
							</button>
						)}
						<button
							className="button is-info  is-hidden-touch"
							onClick={() =>
								window.open(
									`/print-estimate/${this.props.match.params.projectLeadId}`
								)
							}
						>
							Print
						</button>
						<button
							className="button is-info "
							onClick={this.handleEditProjectRequest}
						>
							Edit
						</button>
						<button
							className="button is-info"
							onClick={() =>
								this.setState({
									showDuplicationModal: true,
									duplicateProjectName:
										this.props.focusedLoanEstimate?.project_lead?.project_name +
										' Duplicate',
								})
							}
						>
							Duplicate
						</button>
					</div>
				</div>
			</div>
		);
	};

	generateProjectAlerts = () => {
		if (!(this.state.data?.alerts || []).length) return <></>;

		console.log('alert check', this.state.data.alerts);

		return (
			<div className="mt-4">
				{this.state.data.alerts.map((alert) => (
					<div className="my-4">
						<AlertCard {...alert} />
					</div>
				))}
			</div>
		);
	};

	renderTopNotes = () => {
		if (
			['PACE', 'PACE PPA'].includes(this.state.typeDisplay) &&
			(this.state.data?.pace_community_notes || []).length
		) {
			return (
				<NotesCard
					title={
						'Notes about PACE in ' +
						this.state.data.pace_community_notes[0].district
					}
					notes={this.state.data.pace_community_notes.map((d) => d.text_value)}
				/>
			);
		}
	};

	getTopAlerts = () => {
		let { typeDisplay, data } = this.state;
		let alerts = [];
		if (typeDisplay === 'PPA') {
			alerts.push(
				<div className="my-4">
					<AlertCard
						type="warning"
						msg={
							<>
								<p>
									These numbers rely on your figures for the size and expected
									first year kWh production of your solar system.
									<br /> You told us that your planned system is&nbsp;
									<span className="has-text-weight-semibold">
										{formatters.number.formatter(
											data?.project_lead?.solar_system_size
										)}{' '}
										kW
									</span>
									, and will produce&nbsp;
									<span className="has-text-weight-semibold">
										{formatters.number.formatter(
											data?.project_lead?.solar_system_annual_production
										)}{' '}
										kWh
									</span>
									&nbsp; in its first year.
								</p>
								<p className="mt-2">
									Due to the numerous methods used by PPA investors to calculate
									their offers, CleanFi uses standard industry methods for
									returning the indicatives presented here. We also assume a 25%
									Federal Tax rate and other variables which may not apply to
									your specific project. The only way to receive reliable
									numbers for a PPA is to apply.
								</p>
							</>
						}
					/>
				</div>
			);

			alerts.push(
				<div className="my-4">
					<AlertCard
						type="danger"
						msg={
							<span>
								In a PPA deal, you will not be able to claim any tax benefits
								because the system is owned by the lender. The cost per kWh
								listed below is based on the full cost of your improvements,
								which is{' '}
								<span className="has-text-weight-semibold">
									{formatters.USDCurrency.formatter(
										data?.project_lead?.amount +
										data?.project_lead?.tax_benefits_available
									)}
								</span>
							</span>
						}
					/>
				</div>
			);
		}

		// handle case of missing PPA data
		let is_solar =
			(data.project_lead.improvements || []).findIndex((d) => d.id === 32) > -1;

		return alerts;
	};

	handleOptionClick = (selected, id) => {
		let index = this.state.shareModalSpecOptionIds.indexOf(id);

		if (selected) {
			this.state.shareModalSpecOptionIds.push(id);
		} else {
			this.state.shareModalSpecOptionIds.splice(index, 1);
		}

		this.setState({
			data: {
				...this.state.data,
				estimates: this.state.data.estimates.map((d) => ({
					...d,
					selected: this.state.shareModalSpecOptionIds.includes(id),
				})),
			},
		});
	};

	handleAmortizationModalClose = () => {
		this.setState({ amortizationModalOpen: false });
	};

	renderDisplayedSection = () => {
		let { typeDisplay, data } = this.state;
		let estimates = data.estimates || [];
		let displayable = [];
		let explanation = '';

		if (!estimates.length)
			return (
				<div className="box">
					<div>
						<p className="is-size-5 has-text-primary">
							No Financing Options Available
						</p>
					</div>
				</div>
			);

		// loop over all estimates for filtering and data display, including assigning lables
		let typeCount = {};
		for (let i = 0; i < estimates.length; i++) {
			let estimate = estimates[i];
			if (estimate.product?.type && !typeCount[estimate.product?.type]) {
				typeCount[estimate.product.type] = 1;
			} else {
				typeCount[estimate.product.type] += 1;
			}

			if (this.state.displayedTypes.includes(estimate.product?.type)) {
				estimate.label = `${estimate.product.type} Option ${
					typeCount[estimate.product.type]
				}`;
				displayable.push(estimate);
			}
		}

		explanation = explanations[typeDisplay];
		return (
			<div>
				{/* <div className="mb-6">
                    <AlertCard
                        type="info"
                        msg={explanation}/>
                </div> */}

				{this.renderTopNotes()}
				{this.getTopAlerts()}
				{displayable.map((estimate, idx, displayables) => (
					<LoanEstimateCard
						key={estimate.id}
						showType
						estimate={estimate}
						title={estimate.label}
						index={idx + 1}
						hasPriviledges={!this.state.shared_version}
						onApply={() => this.handleApplyRequest(estimate)}
						onShare={() =>
							this.setState({
								shareModalOpen: true,
								shareModalSpecOptionIds: [estimate.id],
							})
						}
						onAmortization={(id) =>
							this.setState({
								amortizationModalOpen: true,
								amortizationOptionId: estimate.id,
								amortizationLineId: id,
							})
						}
						tax_benefit={
							data?.project_lead?.tax_benefit_request === 'w_financing'
						}
						amount={data?.project_lead?.amount}
						tax_benefit_percentage={data?.project_lead?.improvements[0]?.tax_benefit_percentage}
					/>
				))}

				{!displayable.length && (
					<div className="box mt-2 mb-6">
						<div>
							<p className="is-size-5 has-text-grey">
								All options have been filtered out.
							</p>
						</div>
					</div>
				)}
			</div>
		);
	};

	// filterEstimatesCard = () => {

	//     return (
	//         <div className="">
	//             <div className="box">
	//                 <p className="is-size-5  mb-4">Filter Estimates</p>
	//                 <Input
	//                     type="select"
	//                     label="Financing type"
	//                     value={this.state.typeDisplay}
	//                     onChange={val => this.setState({ typeDisplay: val })}
	//                     options={[
	//                         { value: 'all', display: 'All' },
	//                         ...this.state.availableTypes.map(d => ({ value: d, display: d }))
	//                     ]}
	//                 />
	//             </div>
	//         </div>
	//     )
	// }

	getSummaryCard = () => {
		let estimates =
			this.state.data?.estimates.filter((d) => d?.product?.type != 'PPA') || [];

		// create an array of each type. Then create a dictionary of the range of interest rates for each type, the range of terms, and the range of payments. Also provide the count of each type
		let typeDict = {};
		estimates.forEach((d) => {
			let type = d?.product?.type;
			if (!typeDict[type]) {
				typeDict[type] = {
					count: 0,
					rates: [],
					terms: [],
					payments: [],
				};
			}
			typeDict[type].count += 1;

			d.attributes.forEach((a) => {
				typeDict[type].rates.push(a.rate);
				typeDict[type].terms.push(a.term);
				typeDict[type].payments.push(a.schedule?.[0]?.payment);
			});
		});

		let summary = Object.keys(typeDict).map((d) => {
			let { rates } = typeDict[d];
			let { terms } = typeDict[d];
			let { payments } = typeDict[d];

			return {
				type: d,
				count: typeDict[d].count,
				min_rate: Math.min(...rates),
				max_rate: Math.max(...rates),
				min_term: Math.min(...terms),
				max_term: Math.max(...terms),
				min_payment: Math.min(...payments),
				max_payment: Math.max(...payments),
			};
		});

		let summaryDisplay = (
			<div className="columns is-multiline">
			  {summary.map((d) => (
				<div className="column">
				  <MultiSelectBox
					selected={this.state.displayedTypes.includes(d.type)}
					onSelect={() => {
					  this.setState({
						displayedTypes: this.state.displayedTypes.includes(d.type)
						  ? this.state.displayedTypes.filter((e) => e !== d.type)
						  : [...this.state.displayedTypes, d.type],
					  });
					}}
				  >
					
					<div
					  style={{
						display: "flex",
						alignItems: "flex-start",
						justifyContent: "space-between",
						gap: "8px",
						minHeight: "3.2rem", 
					  }}
					>
					  <h5
						className="is-size-5 has-text-primary"
						style={{
						  margin: 0,
						  flex: 1,                 
						  wordBreak: "break-word", 
						}}
					  >
						{startCase(d.type)}
					  </h5>
		  
					  {d.type !== "Loan" && (
						<span
						  className="icon has-text-info tooltip"
						  onClick={(e) => {
							e.stopPropagation();
		  
							let url = "";
							if (d.type === "Capital Lease") {
							  url = "https://blog.cleanfi.com/what-is-a-capital-lease/";
							} else if (d.type === "PACE") {
							  url =
								"https://blog.cleanfi.com/what-is-c-pace-property-improvement-financing/";
							} else if (d.type === "Solar Power Agreement") {
							  url = "https://blog.cleanfi.com/spa/";
							}
		  
							if (url) window.open(url, "_blank");
						  }}
						  style={{
							cursor: "pointer",
							fontSize: "22px",
							display: "inline-flex",
							alignItems: "center",
							justifyContent: "center",
							flexShrink: 0, 
						  }}
						  onMouseDown={(e) => e.stopPropagation()}
						  onTouchStart={(e) => e.stopPropagation()}
						>
						  <i className="fas fa-question-circle" />
						  <span className="tooltiptext">Learn more</span>
						</span>
					  )}
					</div>
		  
					
					<div>
					  <p className="is-size-6 mb-0">{d.count} Options</p>
					</div>
		  
					
					{d.type !== "Solar Power Agreement" ? (
					  <div>
						{!(isNaN(d.min_rate) || Math.abs(d.min_rate) === Infinity) && (
						  <div>
							{d.min_rate}% - {d.max_rate}% {/* Interest row */}
						  </div>
						)}
						{!(isNaN(d.min_term) || Math.abs(d.min_term) === Infinity) && (
						  <div>
							{d.min_term} - {d.max_term} years {/* Years row */}
						  </div>
						)}
					  </div>
					) : (
						
						<div>
						<div className="has-text-grey">
						  Not applicable
						</div>
						{!(isNaN(d.max_term) || Math.abs(d.max_term) === Infinity) && (
						  <div>{d.max_term} years</div>
						)}
						
					  </div>
					)}
				  </MultiSelectBox>
				</div>
			  ))}
			</div>
		  );

		return (
			<ToggleCard title="Summary" active>
				{summaryDisplay}
				<p className="italic is-size-7">
					Click on boxes to toggle display of each loan type.
				</p>
			</ToggleCard>
		);
	};

	getContactCard = () => {
		return (
			<AlertCard type="info">
				<div>
					<p className="has-text-weight-semibold has-text-primary">
						Questions?
					</p>
					<p>
						Call us: <TelephoneNumber />
					</p>
					<p>
						Email us at: <ContactEmail />. Please hit the "share" button at the
						top of this page and include that link in your email.
					</p>
				</div>
			</AlertCard>
		);
	};

	renderBidDeskView = () => {
		return (
			<div>
				<div
					className="button is-primary mb-4"
					onClick={() => this.setState({ bidDeskView: false })}
				>
					Return to Viewing Loans
				</div>
				<PPADisplay
					onApply={() =>
						this.handleApplyRequest(
							this.state.data.estimates.find((d) => d.product?.type === 'PPA')
						)
					}
				/>
			</div>
		);
	};

	render() {
		const { data, loading } = this.state;
		if (!loading && (!data?.estimates.length || this.state.error))
			return this.generateNoFunderCase();
		return (
			<FormFlowWrapper controlWidth>
				<div className="px-2">
					{this.generateTitle()}
					<ProjectCard project={this.state.data.project_lead}>
						{/* <p className="is-italic mt-4 has-text-grey">These estimates include all known fees. Because fees are capitalized, payments are based on an amount that may be higher than the project total listed above. Please READ THE NOTES before selecting a product.</p> */}
						{/* <p>Got Questions? Call us: <span className="has-text-weight-semibold"><TelephoneNumber /></span></p> */}
					</ProjectCard>

					<div className="my-2">
						<HowThisWorksCard />
					</div>
					<div className="mt-2 mb-6">{this.getContactCard()}</div>

					<div className="my-2">{this.getSummaryCard()}</div>

					{Array.isArray(data.funders_eligible_for_ppa) &&
					data.funders_eligible_for_ppa.length > 0 && (
						<div className="my-2">
							<ToggleCard
								title="This project is also eligible for a PPA through BidDesk"
								active
							>
								<p>
									CleanFi does not instantly quote PPA’s. Upload your project to
									BidDesk, and qualified investors will each have the option to
									offer a bid. You will receive an email notification each time
									an offer is logged, and be able to select the one you want to
									apply for. At that point CleanFi will facilitate the
									application for full underwriting of the project and the
									off-taker.
								</p>

								{/* Admin Info */}
								<div className="mt-3">
									<AdminInfoLoanEstimate
										title="Admin Info"
										notes={data.funders_eligible_for_ppa.map((row) => {
											const [name, product] = row || [];
											return {
												title: name || 'Funder',
												note: product || '',
											};
										})}
									/>
								</div>

								<div
									className="button"
									onClick={() => this.setState({ bidDeskView: true })}
								>
									Learn More
								</div>
							</ToggleCard>
						</div>
					)}

					{this.generateProjectAlerts()}

					<div className="divider mb-6" />
					{/* CARD DISPLAY */}
					{this.state.bidDeskView
						? this.renderBidDeskView()
						: this.renderDisplayedSection()}

					{this.state.shareModalOpen && (
						<LoanEstimateShareModal
							data={this.state.data}
							specOptionId={this.state.shareModalSpecOptionIds}
							visible
							onOptionValueChange={this.handleOptionClick}
							onAccept={() => this.setState({ shareModalOpen: false })}
						/>
					)}

					<AmortizationModal
						title="Amortization"
						visible={this.state.amortizationModalOpen}
						data={this.state.data}
						specOptionId={this.state.amortizationOptionId}
						lineId={this.state.amortizationLineId}
						onClose={this.handleAmortizationModalClose}
					>
						<div className="py-4">
							<button
								className="button is-primary"
								onClick={this.handleAmortizationModalClose}
							>
								Close
							</button>
						</div>
					</AmortizationModal>

					<AlertCard type="info">
						<p className="is-size-7">
							This document presents financing indicative(s) only, based on
							rates and product features offered by participating funders at the
							moment of your inquiry - This document is not a funding offer. It
							is an indication of the financing options available for projects
							like yours at the moment of your inquiry.{' '}
							<span>
								The property address listed here may not qualify for reasons of
								valuation, debt ratio, title issues or multiple other factors.
							</span>{' '}
							Actual payments would be based on pre-underwriting findings, the
							credit profile of the applicant, the calendar date the financing
							agreement is signed, changes in rates, underwriting guidelines,
							points and fees associated with this funder, program and/or
							financing product at the time of your application, PACE program
							requirement changes, and other factors.{' '}
							<span className="has-text-weight-semibold">
								CleanFi and CleanFinancing LLC make no representation here about
								the funding viability of your project.
							</span>
						</p>
					</AlertCard>

					{this.state.showLoginModal && (
						<LoginModal
							visible
							onClose={() => this.setState({ showLoginModal: false })}
							onLogin={(userData) => {
								this.setState({ showLoginModal: false });
								if (this.state.applicationLoanEstimate) {
									this.handleApplyRequest(this.state.applicationLoanEstimate);
								}
							}}
						/>
					)}

					{this.state.showDuplicationModal && (
						<FormModal
							title="Duplicate Project"
							visible
							inputs={[
								{
									type: 'text',
									label: 'Name',
									dataKey: 'name',
									value: this.state.duplicateProjectName,
									...validators.isStringOfMinLength(2),
								},
							]}
							disableAutocomplete
							onSubmit={this.handleDuplicateProjectRequest}
							onCancel={() =>
								this.setState({
									showDuplicationModal: false,
									duplicateProjectName: null,
								})
							}
						/>
					)}
				</div>
			</FormFlowWrapper>
		);
	}
}

const mapStateToProps = (state) => ({
	focusedProject: state.projectLeads.focusedProject,
	focusedLoanEstimate: state.projectLeads.focusedLoanEstimate,
	isAdmin: state.user.decodedTokenData.admin,
	userData: state.user.decodedTokenData,
	loaderOn: state.session.globalLoaderOn,
});

const mapDispatchToProps = (dispatch) => ({
	// focused project is alwasy ust the id
	setFocusedProject: (data) =>
		dispatch(actions.projectLeads.setFocusedProject(data)),
	updateInfoFeedDisplay: (data) =>
		dispatch(actions.infoFeed.updateInfoFeedDisplay(data)),
	clearInfoFeedDisplay: (data) =>
		dispatch(actions.infoFeed.clearInfoFeedDisplay(data)),

	updateInputs: (data) => dispatch(actions.formFlow.updateFormFlowInputs(data)),
	updateComputed: (data) =>
		dispatch(actions.formFlow.updateFormFlowComputed(data)),
	updateCurrentStep: (data) =>
		dispatch(actions.formFlow.setFormFlowCurrStep(data)),
	clearFormFlow: () => dispatch(actions.formFlow.clearFormFlow()),
	setFocusedLoanEstimate: (data) =>
		dispatch(actions.projectLeads.setFocusedLoanEstimate(data)),
	resetApplicationData: () =>
		dispatch(actions.applicationData.resetApplicationData()),
	setSessionVar: (data) => dispatch(actions.session.setVar(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoanEstimateScreen);
